import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-number-revers',
  templateUrl: './number-revers.component.html',
  styleUrls: ['./number-revers.component.scss']
})
export class NumberReversComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
